<template>
  <path
    d="M12 20.0002C16.4183 20.0002 20 16.4185 20 12.0002C20 7.5819 16.4183 4.00018 12 4.00018C7.58172 4.00018 4 7.5819 4 12.0002C4 16.4185 7.58172 20.0002 12 20.0002Z"
  />
</template>
